import React from "react";
import "../styles/PrivacyPolicyStyle.css";

const JZCTerms = () => {
  return (
    <div class="jazz_discount_outer">
      <div class="container">
        <div class="discount_inner">
          <h2>Terms & Condition</h2>
          <br></br>
          <br></br>
          <h3>JU Terms of Use</h3>
          <br></br>
          <p>
            Salam/Greetings! and a very warm welcome to the Terms of Use
            (“Terms”) of JobUp (“JobUp", "JU", "We", "Us”, or “Our”). Our app is
            designed to help job seekers find their dream job quickly and
            easily, with a range of features and tools to streamline the job
            search process. With access to local and global job listings,
            personalized job matching, and live interview features, our app is
            the perfect tool for anyone looking to take their career to the next
            level. By accessing or using the Platform (defined below) you agree
            to be bound by these Terms. Your agreement with us includes these
            Terms, the Privacy Policy available at
            https://jobup.mobi/privacypolicy
          </p>
          <br></br>
          <p>
            IF YOU DO NOT AGREE WITH THESE TERMS, THEN PLEASE REFRAIN FROM USING
            THE PLATFORM. BY ACCESSING OR USING THE PLATFORM, YOU IRREVOCABLY
            ACCEPT THE AGREEMENT AND AGREE TO ABIDE BY THE SAME (AS UPDATED FROM
            TIME TO TIME).
          </p>
          <br></br>
          <p>
            If you have downloaded Our PWA / App from Google Play Store, You
            will also be subject to Google Play Terms of Service. If there is
            any conflict between Google Play Terms of Service and this Agreement
            with respect to your use of the App, then, this Agreement shall
            prevail.
          </p>
          <br></br>
          <h3>Definitions</h3>
          <br></br>
          <p>
            “Subscription” is an access model of the product where subscribers
            get access to the Portal
          </p>
          <br></br>
          <p>
            “Subscriber” is a User (defined below) who has paid a subscription
            fee as defined to access that content.
          </p>
          <br></br>
          <p>
            “Personal Information” means any information that relates to a
            natural person, which, either directly or indirectly, in combination
            with other information available or likely to be available with a
            body corporate, is capable of identifying such a person.
          </p>
          <br></br>
          <p>
            “Platform” means the website available at https://jobup.mobi and any
            sub domains (“Website”)and the JU mobile application on Android (
            “Application”).
          </p>
          <br></br>
          <p>“Territory” shall mean Pakistan.</p>
          <br></br>
          <p>“Billing Provider” shall mean eConceptions.</p>
          <br></br>
          <h3>Parties to the Agreement</h3>
          <br></br>
          <p>
            These Terms describe a contractual agreement between You, the User
            of the Platform, and JU regarding Your use of the Platform. JU has
            the right to refuse access at its discretion for any or no reason.
            Without limiting the foregoing, You specifically acknowledge that JU
            reserves the right to terminate or limit Your access in the event
            that JU determines, in its sole discretion, that You have violated
            the policies of JU or any forum used by You, including the
            activities that adversely affect the experience of other Users.
          </p>
          <br></br>
          <h3>Eligibility Criteria for User(s)</h3>
          <br></br>
          <p>
            You must be of legal age as applicable in local law or at least 4
            years of age to access and use the JU Platform. If You are between
            the age of 4 to 17 years, your access to the Platform should be
            permitted by Your parent or legal guardian. You (or Your
            parent/guardian) must agree to be bound by these Terms; You must be
            a resident of the country the billing provider you have used to
            enter is operating in; If You do not meet any or all of these
            criteria, please DO NOT use the JU Platform.
          </p>
          <br></br>
          <h3>General Disclaimers</h3>
          <br></br>
          <p>
            By use of the Platform, You agree that You meet with the Eligibility
            Criteria as detailed in Clause 2 (above) and that You are fully able
            and competent to understand and accept this Agreement as a binding
            contract and to abide by all Terms.
          </p>
          <br></br>
          <p>
            You shall not access the Platform by any other means other than
            through the interfaces that are provided by JU and not acquire,
            copy, or monitor any portion of the Platform in any way to reproduce
            or circumvent the navigational structure or presentation of the
            Platform, to obtain or attempt to obtain any materials, documents,
            or information through any means not specifically made available
            through the Platform.
          </p>
          <br></br>
          <p>
            You shall not host, display, upload, modify, publish, or share any
            information on the Platform that belongs to another person to which
            You do not have any right to; or is grossly harmful, blasphemous,
            defamatory, obscene, pornographic, pedophilic, libelous, invasive of
            another’s privacy, hateful, racially objectionable, disparaging,
            relating to encouraging money laundering or gambling or otherwise
            unlawful in any manner; or engages in any activity that interferes
            with or disrupts access to the Platform or JU servers / networks; or
            falsifies or deletes any author attributions, legal or other
            notices, proprietary designations, labels of the origin or source of
            software ,or other material on the Platform.
          </p>
          <br></br>
          <p>
            JU shall not be liable for any misuse of the Personal Information
            shared by You with Us or a third party on Your profile on the
            Platform.
          </p>
          <br></br>
          <p>
            JU reserves the right to change the Terms from time to time, and
            such changes will be applicable to You if You continue to use the
            Platform at any time after such changes are posted on the Platform.
            Where We believe that any changes are material, We will notify You
            through either an in-app notification, or SMS, or push
            notifications, or email You have provided Us, but regardless of
            whether You receive such notice, any changes will become effective
            if You use any of the Platform at any time after such changes are
            published on this page. We recommend that you visit this page
            periodically to be sure You are aware of the most recent Term
          </p>
          <br></br>
          <p>
            If You do not agree to these Terms, do not use any of the Platform,
            and if You do not wish to agree to any changes to these Terms,
            please cease using the Platform.
          </p>
          <br></br>
          <h3>Service Subscription and unsubscription:</h3>
          <br></br>
          <p>
            Service Subscription: The service is provided to Billing Provider’s
            customers at a subscription fee and this subscription can be
            purchased at{" "}
            <a href="https://jobup.mobi/home">https://jobup.mobi/home</a> and
            other advertising links as promoted by JU
          </p>
          <br></br>
          <p>
            Subscribers can opt for the following subscription plan(s) to avail
            access to JU.
          </p>{" "}
          <br></br>
          <br></br>
          <table>
            <tr>
              <th>Pricing Model</th>
              <th>Basic</th>
              <th>Standard</th>
              <th>Premium</th>
              <th>Validity(days)</th>
            </tr>
            <tr>
              <td>Weekly</td>
              <td>Rs.100</td>
              <td>Rs.125</td>
              <td>Rs.150</td>
              <td>7</td>
            </tr>
            <tr>
              <td>Monthly</td>
              <td>Rs.360</td>
              <td>Rs.460</td>
              <td>Rs.560</td>
              <td>30</td>
            </tr>
          </table>
          <br></br>
          <p>
            To cancel the service, unsubscribe at{" "}
            <a href="https://jobup.mobi">https://jobup.mobi</a> or by going to
            Settings under My Account section of JobUp or Send UNSUB to service
            short code 3711
          </p>
          <br></br>
          <h3>Conditions for providing information to Service users:</h3>
          <br></br>
          <p>
            During Service activation, the subscriber consents to receiving text
            messages for new features/updates in JU. Text messages are sent from
            Billing Provider’s Network which does not incur any charges. JU
            reserves the right to change the subscription fee or run special
            offers from time to time in which it can offer discounted or free
            subscriptions to Billing Provider’s customers.
          </p>
          <br></br>
          <h3>JU’s Rights</h3>
          <br></br>
          <h3>JU shall:</h3>
          <br></br>
          <p>
            JU reserve the right to change the accepted method of payment or
            billing provider at its sole discretion;
          </p>
          <br></br>
          <h3>No Guarantees</h3>
          <br></br>
          <p>Among other things, JU does not guarantee that:</p>
          <br></br>
          <p>The Platform will meet the User’s expectations; or</p>
          <br></br>
          <p>
            The Platform will be accessible without interruption or in a timely,
            reliable, or fault- free manner; or
          </p>
          <br></br>
          <p>
            The results obtained through use of the Platform will be as per
            users expectations deemed as correct and reliable; or
          </p>
          <br></br>
          <p>
            The quality of the products, services, information, or other
            material Won or obtained by the User through the Platform will meet
            the User’s expectations.
          </p>
          <br></br>
          <p>
            The User shall be solely responsible for damages to his or her data
            system or for loss of data arising from downloads of content from
            the Platform.
          </p>
          <br></br>
          <p>
            No guidance or information, written or oral, obtained from JU or via
            the Platform, shall constitute any warranty, which has not
            specifically been stated in these Terms.
          </p>
          <br></br>
          <h3>Limitation of Liability</h3>
          <br></br>
          <p>
            Users specifically acknowledge and agree that in no event shall JU
            be liable for any direct or indirect damage, including but not
            limited to, delay, damages caused by unused opportunity of the
            Platform, loss of profits, goodwill, licenses of data, or other
            financial loss arising out of: the use of the Platform or inability
            to use the Platform; costs arisen from acquiring are placement of
            any product or service that is based on any item, data, information,
            or service purchased through the Platform, from any message received
            through the Platform or any transactions made by means of the
            Platform; third party claims against the subscriber; unlawful access
            to or modifications of data transmissions; or any other
            circumstances related to the Platform.
          </p>
          <br></br>
          <p>
            JU exempts itself from any claims for damages relating to the
            Platform access, function, quality, possible errors such as spelling
            errors, bugs, and other factors relating to the Platform
          </p>
          <br></br>
          <p>
            JU shall not be liable for any indirect or unforeseeable damages
            caused to the Users under any given circumstances.
          </p>
          <br></br>
          <p>
            The User(s) shall maintain confidentiality of his/her User
            credentials and shall be responsible for any access made through
            his/her account. The User shall immediately notify JU of any actual
            or suspected unauthorized use of User’s credentials and may be
            liable for the JU’s losses or such other parties as the case may be,
            due to any unauthorized use.
          </p>
          <br></br>
          <h3>Force Majeure</h3>
          <br></br>
          <p>
            JU shall not be liable for any damages what so ever arising out of
            force majeure or other similar circumstances, directly or indirectly
            affecting JU and unreasonably complicating JU’s activities. Examples
            of force majeure events are real or potential labour disputes,
            governmental actions, war or threat of war, sabotage, civil unrest,
            demonstrations, fire, storm, flooding, explosion, earthquake,
            provisions or limitations of materials or resources, inability to
            obtain the relevant authorization, accident, and defect in
            electricity or telecommunication network. Force majeure or other
            event beyond JU’s control hindering, delaying or complicating the
            maintenance of the Platform entitles the JU to suspend or limit the
            Platform until further notice.
          </p>
          <br></br>
          <h3>Intellectual Property Rights</h3>
          <br></br>
          <p>
            The content of the Platform is protected by international copyright
            acts and treaties. All reproduction or distribution of any material
            on the Platform, including but not limited to text, photographs,
            movies, music and software programs is strictly prohibited, unless
            explicitly stated otherwise. JU reserves any and all rights not
            expressly granted herein.
          </p>
          <br></br>
          <p>
            JU’s trade name, logotype, and all related trademarks, product
            and/or service names and slogans used in the Platform are the
            property of JU and may not be used in any way without the prior
            written approval of JU. Users use of the Platform shall not be
            construed as the grant of any license or right to use any trademarks
            or names appearing on the Platform.
          </p>
          <br></br>
          <h3>Advertisements</h3>
          <br></br>
          <p>
            JU may include or offer third party products on the Platform through
            digital advertisements, whether fetched directly from advertisers or
            sourced from ad networks JU shall not be liable for any privacy
            practices or the content shared by the business partners,
            advertisers, sponsors or other websites to which JU provides links
            on the Platform. The Users shall be responsible for checking the
            privacy policy and terms of use of such third- parties before
            exploring their websites to safeguard their interests.
          </p>
          <br></br>
          <h3>Term and Termination</h3>
          <br></br>
          <p>
            <span style={{ color: "red" }}>Term:</span> This Agreement is valid
            until further notice.
          </p>
          <br></br>
          <p>
            JU may at its sole discretion and without prior notice, suspend/
            freeze/ terminate the User’s access to the Platform if he/she
            violates or attempts to violate the security of the Platform
            including, without limitation
          </p>
          <br></br>
          <p>
            accessing data not intended for You or logging on to a server or the
            User is not authorized to use; attempting to probe, scan or test the
            vulnerability of the system or network or to breach security or
            authentication measures without authentication; or accessing or
            using the Platform without authorization, in violation of these
            Terms or in violation of applicable law.
          </p>
          <br></br>
          <p>
            Violations of system or network security may result in civil or
            criminal liability. JU will investigate occurrences that may involve
            such violations and cooperate with law enforcement authorities in
            prosecuting Users who are involved in such violations. You agree not
            to use any device, software, or routine to interfere or attempt to
            interfere with the proper working of this Platform or any activity
            being conducted on this Platform.
          </p>
          <br></br>
          <p>
            JU may at its sole discretion and without prior notice, suspend,
            freeze or terminate the Subscriber Account under the following
            circumstances:
          </p>
          <br></br>
          <p>
            The Subscriber violates any or all terms of this Agreement or
            instructions on the Platform;
          </p>
          <br></br>
          <p>
            JU has reason to suspect a crime, misuse, fraud, or attempt of such
            in relation to use of the Platform;
          </p>
          <br></br>
          <p>
            JU considers it to be necessary for safety reasons or JU’s
            reputation; or JU is forced to do so pursuant to legislation or
            ruling of a competent authority.
          </p>
          <br></br>
          <h3>Indemnity</h3>
          <br></br>
          <p>
            The Users shall indemnify, defend, and hold harmless JU and its
            affiliates, if any, from and against any and all losses,
            liabilities, claims, suits, proceedings, penalties, interests,
            damages, demands, costs, and expenses (including legal and statutory
            fees and disbursements in connection therewith and interest
            chargeable thereon) asserted against or incurred by JU that arise
            out of, result from, or in connection with: the User’s breach of
            these Terms;
          </p>
          <br></br>
          <p>
            any claims made by any third party due to, or arising out of, or in
            connection with User’s use of JU Platform or participation in a
            Campaign on the Platform or winning/claiming the reward of such
            Campaign;
          </p>
          <br></br>
          <p>
            the User’s violation of any rights of another, including
            intellectual property rights;and the User’s violation of any
            applicable laws.
          </p>
          <br></br>
          <p>
            Not with standing anything to the contrary in these Terms, in no
            event shall JU and its affiliates, if any, be liable to the User or
            anyone claiming through the User in respect of any subject matter of
            these Terms.
          </p>
          <br></br>
          <h3>Applicable Law and Jurisdiction</h3>
          <br></br>
          <p>
            These Terms shall be governed by the laws of territory. You agree
            that JU is solely based in Islamabad Pakistan, and nothing shall
            give rise to personal jurisdiction over us in jurisdictions other
            than Pakistan and you shall not raise any claims against us in any
            court or forum in any jurisdiction other than Pakistan. Any claim or
            dispute between the Subscriber and JU will be entertained and tried
            solely and exclusively by a court of competent jurisdiction located
            in Pakistan and no other place whatsoever.
          </p>
          <br></br>
          <h3>Severability</h3>
          <br></br>
          <p>
            If, for any reason, a court of competent jurisdiction finds any
            provision of the Terms, or portion there of, to be unenforceable,
            that portion shall be enforced to the maximum extent permissible so
            as to give effect to the intent of the parties as reflected by that
            provision. The remainder of the Terms shall continue in full force
            and effect.
          </p>
          <br></br>
          <h3>Waiver</h3>
          <br></br>
          <p>
            No provision of this Agreement shall be deemed to be waived and no
            breach excused, unless such waiver or consent shall be in writing
            and signed by JU. Any consent by JU to, or a waiver by JU of any
            breach by the User, whether expressed or implied, shall not
            constitute consent to, waiver of, or excuse for any other different
            or subsequent breach
          </p>
        </div>
      </div>
    </div>
  );
};

export default JZCTerms;
